if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor(){
      super();  
    }

    connectedCallback(){
      this.productId                = this.dataset?.productId;
      this.cartSidebar              = document.querySelector('.cart-sidebar');
      this.submitForm               = this.querySelector('.submit-form');
      this.productInventory         = this.querySelector('.product-inventory');
      this.productInventoryTransfer = this.querySelector('.product-inventory-transfer');
      this.productComplementary     = this.querySelector('.product-complementary');
      this.btnSubmit                = this.submitForm?.querySelector('[name="add"]');

      this.variantPicker            = this.querySelector('variant-picker');
      this.quantityInput            = this.querySelector('quantity-input');

      this.formVariantId = this.submitForm?.querySelector('[name="id"]');
      if(this.formVariantId){
        this.formVariantId.disabled = false;
      }

      let variantData = window.theme?.productVariants?.[this.productId];
      if(variantData){
        this.qtyTabls = window.getQtyTable(variantData);
      }else if(this.variantPicker){
        customElements.whenDefined('variant-picker').then(() => {
          this.qtyTabls = window.getQtyTable(this.variantPicker?.variantData);
        }).catch(error => {
          console.error(error);
        });
      }

      if(this.productInventory){
        const templateInventory = this.productInventory.querySelector('template#variant-inventory');
        if(templateInventory){
          this.variantInventory = JSON.parse(templateInventory.content?.textContent) || null;
        }
      }

      if(this.productComplementary){
        window.initLazyObserver(this.productComplementary,() => {
          this.initComplementary();
        });
      }

			this.addEventListener('variant:change', this.handleVariantChange.bind(this));
      this.debouncedSubmit = window.debounce(this.handleSubmit.bind(this), 300);
      this.submitForm.addEventListener('submit', this.debouncedSubmit.bind(this));
    }

    handleVariantChange(e){
      const variant = e.detail.variant ? e.detail.variant : null;

      if(e.detail?.qtyTabls){
        this.qtyTabls = e.detail.qtyTabls;
      }

      this.inventoryTransfer(variant);

      if(this.productInventory) {
        this.updateInventory(this.variantInventory?.find(v => v.id === variant.id) || null);
      }
    }

    handleSubmit(e) {
      e.preventDefault();
      window.updateBtnStatus(this.btnSubmit, true);

      if(window?.theme?.settings?.cartType == 'page'){
        this.submitForm.submit();
        return;
      }

      const formData = new FormData(this.submitForm);
      formData.append('sections_url', window.location.pathname);
      if (this.cartSidebar) {
        formData.append('sections', `${this.cartSidebar.dataset.sectionId}`);
      }

      const data = {
        formData:formData,
        stapos:{
          staType:'btn',
          staEl:this.btnSubmit,
          posType:'productform',
          posEl:this.cartSidebar
        },
        sectionsUrl:window.location.pathname,
        sections:this.cartSidebar.dataset.sectionId,
        silent:false
      };

      if (this.qtyTabls) {
        window.checkCart(data, window.updateCart);
      } else {
        window.updateCart(data);
      }
    }

    updateInventory(inventory){
      if(!this.productInventory) return;
      if(!inventory){
        this.productInventory.classList.add('d-none');
        return;
      }

      const productInventorySwitch = this.productInventory.querySelector('.product-inventory-switch');
      const inventoryStatus = this.productInventory.querySelectorAll('.product-inventory-status');
      const {showInventoryNotice,showInventoryCount,threshold,textLeftLow,textLeftOk,textLow,textOk} = this.productInventory.dataset;

      const count = inventory.qty;
      const showCount = showInventoryCount === 'always' || (showInventoryCount === 'low' && count <= threshold);
      let notice = null;
      if (showCount) {
        if (count <= threshold) {
          notice = textLeftLow.replace('[QTY]', count);
        } else {
          notice = textLeftOk.replace('[QTY]', count);
        }
      } else {
        if (count <= threshold) {
          notice = textLow;
        } else {
          notice = textOk;
        }
      }
      
      if (inventoryStatus) {
        inventoryStatus.forEach(el => el.textContent = notice);
      }
      if(productInventorySwitch){
        productInventorySwitch.classList.toggle('product-inventory-low', count <= threshold);
        productInventorySwitch.classList.toggle('product-inventory-ok', count > threshold);
        this.productInventory.classList.remove('d-none');
      }
      
    }

    inventoryTransfer(variant){
      if (!this.productInventoryTransfer || !variant?.id) return;

      for (const child of [...this.productInventoryTransfer.childNodes]) {
        if (!(child.nodeType === Node.ELEMENT_NODE && child.tagName === 'TEMPLATE')) {
          child.remove();
        }
      }

      const template = this.productInventoryTransfer.querySelector(`template[data-variant="${CSS.escape(variant.id)}"]`);
      if (!template) return;

      const text = template.content.textContent.trim();
      if (text) {
        const div = document.createElement('div');
        div.textContent = text;
        this.productInventoryTransfer.appendChild(div);
      }
    }

    initComplementary(){
      const url = this.productComplementary?.dataset?.url || '';
      const id = this.productComplementary?.dataset?.id || '';
      if(!url || !id) return;

      fetch(url).then(response => response.text())
        .then(data => {
          const parser     = new DOMParser();
          const doc        = parser.parseFromString(data, 'text/html');
          const getContent = doc.querySelector(`[data-id="${id}"]`);
          if (!getContent) return;

          this.productComplementary.innerHTML = getContent.innerHTML;
          const caro = this.productComplementary.querySelector('[data-slide="carousel"]');
          if (caro) {
            new SimpleCarousel(caro);
          }
        })
        .catch(error => {
          console.error('Error fetching complementary content:', error);
        });
    }

  }

  customElements.define('product-form', ProductForm);
}

if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor(){
      super();
      this.initialized = false;
    }

    connectedCallback(){
      if (this.initialized) return;

      this.productForm   = this.closest('product-form');
      this.galleryType   = this.dataset.galleryType || '';
      this.variantPicker = this.productForm?.querySelector('variant-picker');
      this.swiperMain    = this.querySelector('.swiper-main');
      this.swiperThumbEl = this.querySelector('.swiper-thumbs');
      

      if(this.galleryType == 'carousel'){
        this.initSwiper();
        this.productForm.addEventListener('variant:change', this.handleVariantChange.bind(this));
      }
    }

    handleVariantChange(e){
      const variant = e.detail.variant ? e.detail.variant : null;
      this.setActiveMedia(variant);
    }

    async initSwiper(){
      try {
        await this.loadSwiper();

        if (!this.swiperMain) return;

        this.swiperThumbs();

        const config = this.parseSwiperConfig(this.swiperMain);
        if (!config) return;

        if (this.swiperThumb) {
          config.thumbs = { swiper: this.swiperThumb };
        }

        this.swiper = new Swiper(this.swiperMain, config);

        this.setActiveMedia(this.variantPicker?.variant);

        this.initialized = true;

      } catch (err) {
        console.error('MediaGallery Swiper initialization failed:', err);
      }
    }

    loadSwiper() {
      return new Promise((resolve, reject) => {
        Promise.all([
          window.loadByUrl(window?.theme?.static?.swiperCss, () => {}, { type: 'css', check: 'swipercss' }),
          new Promise((res, rej) => {
            window.loadByUrl(window?.theme?.static?.swiperJs, () => {
              if (typeof window.Swiper === 'function') {
                res();
              } else {
                rej(new Error('Swiper is not available'));
              }
            }, { type: 'js', check: 'Swiper' });
          })
        ])
        .then(resolve)
        .catch(reject);
      });
    }

    parseSwiperConfig(element) {
      if (!element) return null;
      try {
        const config = JSON.parse(element.dataset.config || '{}');
        
        ['prevEl', 'nextEl', 'el'].forEach(key => {
          if (config?.navigation?.[key] && typeof config.navigation[key] === 'string') {
            const el = element.querySelector(config.navigation[key]);
            if (el) config.navigation[key] = el;
          }
        });

        return config;
      } catch (e) {
        console.error('Invalid swiper config:', e);
        return null;
      }
    }

    swiperThumbs() {
      if (!this.swiperThumbEl) return;

      try {
        const config = this.parseSwiperConfig(this.swiperThumbEl);
        if (!config) return;

        this.swiperThumb = new Swiper(this.swiperThumbEl, config);
      } catch (err) {
        console.error('Swiper thumbs initialization failed:', err);
      }
    }

    setActiveMedia(variant){
      if (!variant?.featured_media?.id || !this.swiper) return;

      const matchMedia = this.swiperMain.querySelector(`[data-media-id="${variant?.featured_media?.id}"]`);
      if(!matchMedia) return;

      const index = matchMedia.closest('.swiper-slide')?.dataset?.swiperSlideIndex;
      if(index == undefined) return;

      this.swiper.slideTo(parseInt(index, 10));
      this.productForm.dispatchEvent(new CustomEvent('mediagallery:change', { bubbles: true }));
    }
  }

  customElements.define('media-gallery', MediaGallery);
}

if (!customElements.get('gift-card-recipient')) {
  class GiftCardRecipient extends HTMLElement {
    constructor(){
      super();
    }

    connectedCallback(){
      this.recipientCheckbox   = this.querySelector('.gift-card-recipient-checkbox');
      this.recipientEmailLabel = this.querySelector('.recipient-email-label');
      this.recipientEmail      = this.querySelector('.recipient-email');
      this.recipientName       = this.querySelector('.recipient-name');
      this.recipientMessage    = this.querySelector('.recipient-message');
      this.recipientSendon     = this.querySelector('.recipient-sendon');
      this.recipientOffset     = this.querySelector('.recipient-offset');

      if(this.recipientOffset){
        this.recipientOffset.value = new Date().getTimezoneOffset().toString();
      }

      this.recipientProperties();
      this.recipientCheckbox.addEventListener('change', this.recipientProperties.bind(this));
    }

    recipientProperties(){
      if(this.recipientCheckbox.checked){
        if(this.recipientEmailLabel){
          this.recipientEmailLabel.textContent = this.recipientEmailLabel?.dataset?.jsLabel;
        }
        this.recipientEmail.required = true;
        this.recipientEmail.disabled = false;
        this.recipientName.disabled = false;
        this.recipientMessage.disabled = false;
        this.recipientSendon.disabled = false;
        this.recipientOffset.disabled = false;
      }else{
        this.recipientEmail.required = false;
        this.recipientEmail.disabled = true;
        this.recipientName.disabled = true;
        this.recipientMessage.disabled = true;
        this.recipientSendon.disabled = true;
        this.recipientOffset.disabled = true;
      }
    }
  }

  customElements.define('gift-card-recipient', GiftCardRecipient);
}

if (!customElements.get('sticky-buy')) {
  class StickyBuy extends HTMLElement{
    constructor(){
      super();
    }

    connectedCallback(){
      this.productSection = this.closest('.product-section');
      this.productForm    = this.productSection.querySelector('product-form');
      this.mediaGallery   = this.productForm.querySelector('media-gallery');
      this.swiperThumbs   = this.mediaGallery.querySelector('.swiper-thumbs');

      this.stickyBtn      = this.querySelector('.sticky-atcbtn');
      this.stickyImage    = this.querySelector('.sticky-image');
      this.stickyTitle    = this.querySelector('.sticky-title');
      this.stickyVariant  = this.querySelector('.sticky-variant');

      this.stickyRect = this.getBoundingClientRect();
      this.stickyBuyInitialTop = this.stickyRect.top + window.pageYOffset;
      
      this.stickyBtn.addEventListener('click', this.handleBtnClick.bind(this));
      this.productForm.addEventListener('variant:change', this.handleVariantChange.bind(this));
      this.productForm.addEventListener('mediagallery:change', this.updateStickyImage.bind(this));
      this.updateStickyImage();
    }

    handleBtnClick(e){
      // this.productForm.handleSubmit(e);
      let atcBtn = this.productForm.btnSubmit;
      if(!atcBtn){
        atcBtn = document.querySelector('button[name="add"]');
      }
      atcBtn.click();
    }

    handleVariantChange(e){
      const variant = e.detail.variant ? e.detail.variant : null;
      if(variant){
        this.stickyVariant.textContent = variant.title;
      }
      this.updateStickyImage();
      this.updateStickyBtn(variant);
    }

    updateStickyImage(){
      if(!this.stickyImage) return;
      if(!this.swiperThumbs) return;

      let activeThumb = this.swiperThumbs.querySelector('.swiper-slide-thumb-active');
      if(!activeThumb){
        activeThumb = this.swiperThumbs.querySelector('.swiper-slide-active');
      }
      if(!activeThumb) return;

      this.stickyImage.innerHTML = activeThumb.innerHTML;
    }

    updateStickyBtn(variant){
      if(!this.stickyBtn) return;

      const variantAvailable = variant && variant.available;
      const unavailableStr = variant ? theme?.strings?.noStock : this.stickyBtn?.dataset?.unavailableText;

      this.stickyBtn.textContent = variantAvailable ? this.stickyBtn?.dataset?.btnText : unavailableStr;
    }
  }

  customElements.define('sticky-buy', StickyBuy);
}